import { useQuery } from '@tanstack/react-query';

import { getEmployeeProfile } from '../api/employee.service';
import { resolveEmployeeReferralLink } from '../model';

import { useEmployeeSession } from './use-employee-session';
import {
  type LinkShareResult,
  useLinkShareActions,
} from './use-link-share-actions';

export type ReferralLinkShareResult = LinkShareResult;

export function useEmployeeReferralLinkActions() {
  const { status } = useEmployeeSession();
  const profileQuery = useQuery({
    enabled: status === 'authenticated',
    queryFn: getEmployeeProfile,
    queryKey: ['employee', 'profile'],
  });
  const referralLink = resolveEmployeeReferralLink(
    profileQuery.data?.id ?? null,
  );
  const { copyLink: copyReferralLink, shareLink: shareReferralLink } =
    useLinkShareActions(referralLink);

  return {
    copyReferralLink,
    referralLink,
    shareReferralLink,
  };
}
